export default __webpack_public_path__ + "static/media/studentImg.854bf3c1.png";